import React from 'react';
import { observer } from 'mobx-react';
import { Neo } from '@singularsystems/neo-react';
import { ModalUtils, Validation } from '@singularsystems/neo-core';
import { TextConstants } from '../../../Common/TextConstants';
import FileGroupingFileSpecExportConfigurationComponentVM from '../../ExportFileGroupingFileSpecs/Components/FileGroupingFileSpecExportConfigurationComponentVM';

interface IManageFileGroupingFileSpecExportConfigurationComponentProps {
    viewModel: FileGroupingFileSpecExportConfigurationComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageFileGroupingFileSpecExportConfigurationComponent extends React.Component<IManageFileGroupingFileSpecExportConfigurationComponentProps> {

    public render() {
        const viewModel = this.props.viewModel;

        return (
            <>
                {
                    <Neo.Card title={viewModel.managedFileGroupingExportFileSpec.staticServiceProviderFileGroupingExportFileSpecId > 0 ? TextConstants.Titles.EditBrokerExportConfiguration : TextConstants.Titles.AddBrokerExportConfiguration}>
                        <Neo.Form
                            model={viewModel.managedFileGroupingExportFileSpec}
                            validationDisplayMode={Validation.DisplayMode.AfterSubmit}
                            onSubmit={() => this.props.onSave()}
                            onInvalid={this.onFormInvalid}>
                            <Neo.GridLayout lg={4}>
                                <Neo.FormGroup bindContext={viewModel.managedFileGroupingExportFileSpec.meta.staticServiceProviderGroupingName}>
                                    <Neo.AutoCompleteDropDown
                                        itemSource={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                                        bind={viewModel.managedFileGroupingExportFileSpec.meta.staticServiceProviderFileGroupingId}
                                        bindDisplay={viewModel.managedFileGroupingExportFileSpec.meta.staticServiceProviderGroupingName}
                                        displayMember={"serviceProviderGroupingName"}
                                        readOnly={viewModel.isFieldReadOnlyInd}
                                        items={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0, 10)
                                            .sort((x, y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                                    />
                                </Neo.FormGroup>
                                <Neo.FormGroup bindContext={viewModel.managedFileGroupingExportFileSpec.meta.exportFileTypeConcatenated} label="Export Report Type">
                                    <Neo.AutoCompleteDropDown
                                        itemSource={viewModel.staticExportFileSpecApiClient.getExportFileSpecDropdownList}
                                        bind={viewModel.managedFileGroupingExportFileSpec.meta.staticExportFileSpecId}
                                        bindDisplay={viewModel.managedFileGroupingExportFileSpec.meta.reportName}
                                        displayMember={"propertiesConcatenated"}
                                        readOnly={viewModel.isFieldReadOnlyInd}
                                        items={viewModel.staticExportFileSpecApiClient.getExportFileSpecDropdownList(" ").then((arr) => arr.data.slice(0, 10)
                                            .sort((x, y) => x.propertiesConcatenated!.localeCompare(y.propertiesConcatenated!)))}
                                    />
                                </Neo.FormGroup>
                                <div className="col pt-4">
                                    <Neo.FormGroup
                                        bind={viewModel.managedFileGroupingExportFileSpec.meta.isExcluded}
                                        input={{ type: "switch" }}
                                        label={TextConstants.Labels.Excluded} />
                                </div>

                            </Neo.GridLayout>
                            <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                    onClick={() => this.props.onSave()}
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                        </Neo.Form>
                    </Neo.Card>
                }
            </>
        );
    }
    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage("Save", TextConstants.Validation.InvalidBrokerExportConfiguration);
        }
    }
}